<script>
import {HeaderTabsItems, HeaderTabController} from "./HeaderTabController"


/**
 * @type HeaderTabController
 */
export let controller = {};
export let size = "normal";
export let icon_classes = "";
export let title_classes = "";
export let tabs_classes = "";
export let ul_styles = "";
export let container_classes = "";
export let button_classes = "";
export let button_styles = "";
export let li_styles = "";
export let url_param = "headertab"

export let allow_hash = true;


function ControllerUpdater(item){
    controller = controller;
    controller.on_change(item)

    items = controller.items;
}
controller.ControllerUpdater = ControllerUpdater;

let items = controller?.items ?? [];
let nav_element = null;
let mounted = false;

$: {
    if(controller.items){
        items = controller.items;
    }
}

$: {
    if(nav_element !== null && mounted === false){
        mounted = true;
        items = controller.items.map((item, key)=>{
            let hash = document.location.hash;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            let param = urlParams.get(url_param) ?? null;

            Object.values(item).map((value)=>{

                if(typeof value !== "string"){ return; }

                if(param !== null){
                    if(param.search(value) >= 0){
                        item.set_current(key);
                        return;
                    }
                }

                if(hash.search(value) >= 0){
                    item.set_current(key);
                }
            })

            return item;
        })
    }
}
</script>
{#if items.length !== 0}
    <nav class="columns is-multiline is-centered m-0 {container_classes}" style="width:100%;" bind:this={nav_element}>
        <div class="column is-12 px-0">
            <tabs-container-element class="tabs {size === 'small' ? '' : 'is-centered'}" style="width: 100%;">
                <ul class="ul-options {size === 'small' ? 'is-small-container' : ''}" style="{ul_styles}">
                    {#each items as item, key}
                        <li aria-hidden data-tab={key+1} class="{item.current ? "active":""} tabs {tabs_classes} {size === 'small' ? 'is-small' : ''} {(item.is_disabled?? false) && !item.current? "li-is-disabled":""}" style="{(item?.is_disabled ?? false) ? `pointer-events: none;` : ""} {li_styles}" on:click={
                        (e)=>{
                                e.preventDefault();
                                e.stopPropagation();

                                item.set_current(key);

                                if(allow_hash) {
                                    history.pushState(null, '', '#' + item.tab_name);
                                }
                        }}>
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a class="button is-ghost has-not-animated link-tab {button_classes}" style="{button_styles}">
                                {#if size !== 'small'}
                                    <i class="font-size-24 {item.icon} {icon_classes}"></i>
                                {/if}
                                <h2 class="{size === 'small' ? 'font-size-12' : 'font-restricted-size-16'} fw500 {title_classes}">{item.title}</h2>
                            </a>
                        </li>
                    {/each}
                </ul>
            </tabs-container-element>
        </div>
    </nav>
{/if}
<style>
.ul-options{
    justify-content: center;
}
.ul-options li{
    width: 33.3333334%;
    max-width: 330px;
    /* border-bottom: 1px solid var(--color-extralightGrey); */
    margin-bottom: -0.5px;
    z-index: 10;
}
.ul-options :global(li:not(.active) h2), .ul-options :global(li:not(.active) i){
    color:  var(--color-lighter) !important;
}
.ul-options :global(li:is(.li-is-disabled) h2), .ul-options :global(li:is(.li-is-disabled) i){
    color:  var(--color-mid-grey) !important;
}
.ul-options li .link-tab{
    text-decoration: none;
    /* padding-bottom: 20px; */
}
.ul-options :global(.active .link-tab){
    color:  var(--color-primary) !important;
}
.ul-options :global(.active){
    border-bottom: 1px solid var(--color-primary) !important;
}
.ul-options i{
    margin-right: 15px;
}
.ul-options li :global( a:hover){
    border-bottom-color: var(--color-extralightGrey) !important;
}

.tabs :global(.link-tab){
    border-bottom: none ;
}
li{
    overflow: hidden;
}
li.fit-content-width{
    width: fit-content;
}
li.is-small a{
    padding: 0.3rem 0.75rem !important;
    margin: 0 !important;
}
.ul-options.is-small-container{
    justify-content: flex-start;
}
@media only screen and (max-width:900px){
    tabs-container-element{
        overflow-x: auto;
        max-width: 100vw;
    }
    tabs-container-element .link-tab{
        padding: 10px;
        margin:0;
    }
}
</style>
